import { gql } from "@apollo/client";

export const REGRET_SWIPE_ALERT_QUERY = gql`
	query WebLikesHasSeenRegretSwipeAlert($userId: String!) {
		user(id: $userId) {
			id
			notificationCounts {
				likesIncoming
			}
			likesHasSeenRegretSwipeAlert {
				hasSeen
				expires
			}
		}
	}
`;

export const REGRET_SWIPE_ALERT_MUTATION = gql`
	mutation WebLikesUpdateHasSeenRegretSwipeAlert {
		likesUpdateHasSeenRegretSwipeAlert {
			success
		}
	}
`;



// WEBPACK FOOTER //
// ./src/shared/components/RegretSwipeAlert/queries.js